module.exports = __webpack_public_path__ + "static/media/bk-rewards-inactive.c68b51f9.png";